import {
  CENTER_UPSERT_SUCCESS,
  CENTER_GETALL_SUCCESS,
  CENTER_DELETE_SUCCESS
} from "../actions/types";

const initialState = { centers: null }

export default function (state = initialState, action) {

  const { type, payload } = action;

  switch (type) {
    case CENTER_UPSERT_SUCCESS:
      if (state.centers.filter(e => e.id == payload.id).length > 0) {
        payload.yearsWithBookings = []
        return { ...state, centers: state.centers.map(centerDTO => { return centerDTO.id === payload.id ? payload : centerDTO }) };
      } else {
        console.log('here2')
        return { ...state, centers: [...state.centers, payload] }
      }
    case CENTER_DELETE_SUCCESS:
      return { ...state, centers: state.centers.filter(center => center.id !== payload) }

    case CENTER_GETALL_SUCCESS:
      return { ...state, centers: payload.centers };

    default:
      return { ...state };
  }
}